/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PortfolioMilestoneReachedNotificationPayloadDto,
    PortfolioMilestoneReachedNotificationPayloadDtoFromJSON,
    PortfolioMilestoneReachedNotificationPayloadDtoFromJSONTyped,
    PortfolioMilestoneReachedNotificationPayloadDtoToJSON,
} from './PortfolioMilestoneReachedNotificationPayloadDto';

/**
 * 
 * @export
 * @interface PortfolioMilestoneReachedNotificationDto
 */
export interface PortfolioMilestoneReachedNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof PortfolioMilestoneReachedNotificationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioMilestoneReachedNotificationDto
     */
    portfolioId: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioMilestoneReachedNotificationDto
     */
    portfolioName: string;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioMilestoneReachedNotificationDto
     */
    eventAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioMilestoneReachedNotificationDto
     */
    readAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioMilestoneReachedNotificationDto
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof PortfolioMilestoneReachedNotificationDto
     */
    type: string;
    /**
     * 
     * @type {PortfolioMilestoneReachedNotificationPayloadDto}
     * @memberof PortfolioMilestoneReachedNotificationDto
     */
    payload: PortfolioMilestoneReachedNotificationPayloadDto;
}

export function PortfolioMilestoneReachedNotificationDtoFromJSON(json: any): PortfolioMilestoneReachedNotificationDto {
    return PortfolioMilestoneReachedNotificationDtoFromJSONTyped(json, false);
}

export function PortfolioMilestoneReachedNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioMilestoneReachedNotificationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'portfolioId': json['portfolioId'],
        'portfolioName': json['portfolioName'],
        'eventAt': (new Date(json['eventAt'])),
        'readAt': (json['readAt'] === null ? null : new Date(json['readAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'type': json['type'],
        'payload': PortfolioMilestoneReachedNotificationPayloadDtoFromJSON(json['payload']),
    };
}

export function PortfolioMilestoneReachedNotificationDtoToJSON(value?: PortfolioMilestoneReachedNotificationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'portfolioId': value.portfolioId,
        'portfolioName': value.portfolioName,
        'eventAt': (value.eventAt.toISOString()),
        'readAt': (value.readAt === null ? null : value.readAt.toISOString()),
        'createdAt': (value.createdAt.toISOString()),
        'type': value.type,
        'payload': PortfolioMilestoneReachedNotificationPayloadDtoToJSON(value.payload),
    };
}

